import React from 'react';
import { Stethoscope, ClipboardList, Headset } from 'lucide-react';

const BADGES = [
  { Icon: Stethoscope, label: 'Physician-led care', sub: 'Licensed U.S. providers' },
  { Icon: ClipboardList, label: 'Online assessment', sub: 'Reviewed by a licensed provider' },
  { Icon: Headset, label: 'Ongoing support', sub: 'From your care team' },
];

export default function Marquee() {
  return (
    <section data-testid="trust-strip" className="bg-[color:var(--alfa-sand)]">
      <div className="max-w-[1100px] mx-auto px-5 sm:px-8 py-6 sm:py-5 grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-0">
        {BADGES.map(({ Icon, label, sub }, i) => (
          <div key={label} data-testid={`trust-badge-${i + 1}`} className={`flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-2.5 sm:gap-4 ${i < BADGES.length - 1 ? 'sm:border-r border-neutral-900/15' : ''}`}>
            <span className="shrink-0 w-11 h-11 rounded-full border border-neutral-900/40 flex items-center justify-center">
              <Icon size={19} strokeWidth={1.8} className="text-[color:var(--alfa-ink)]" />
            </span>
            <span>
              <span className="block text-[15.5px] font-medium text-[color:var(--alfa-ink)]">{label}</span>
              <span className="block text-[13.5px] font-medium text-[#5f574e]">{sub}</span>
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
